import { Link } from "react-router-dom";
import { events } from "@/mocks/events";

const rankColor = ["bg-accent-500", "bg-primary-500", "bg-secondary-500", "bg-background-300", "bg-background-300"];

export default function HotRank() {
  const top = [...events].sort((a, b) => a.hot - b.hot).slice(0, 5);

  return (
    <section className="container-x py-12 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600">
            <i className="ri-fire-fill"></i>
            今日热搜
          </span>
          <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            热门事件 TOP 榜
          </h2>
        </div>
        <Link
          to="/events"
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
        {top.map((item, idx) => (
          <Link
            key={item.id}
            to={`/event/${item.id}`}
            className="card group flex flex-col p-4 transition-colors hover:border-primary-300 hover:bg-background-100/60"
          >
            <div className="flex items-center gap-3">
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold text-background-50 ${rankColor[idx]}`}
              >
                {idx + 1}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-eye-line"></i>
                {item.views}
              </span>
            </div>
            <h3 className="mt-3 line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
              {item.title}
            </h3>
            <div className="mt-auto flex items-center gap-2 pt-3">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-700">
                <i className="ri-fire-line text-xs"></i>
                {item.videoCount} 视频
              </span>
              <span className="text-xs text-foreground-400">{item.date.slice(5)}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}